<template>
  <Skeleton v-if="shape === 'rectangle'" shape="rectangle" :height="internalHeightComputed" />
  <Skeleton v-if="shape === 'circle'" shape="circle" :size="internalSizeComputed" />
</template>

<script setup lang="ts">
import Skeleton from 'primevue/skeleton';
import {computed, PropType} from 'vue';
import {Size, Sizes} from '@common/core';

// Types
export type Shape = 'circle' | 'rectangle';

// Props
const props = defineProps({
  height: {
    type: String as PropType<Size>,
    required: false,
    default: 'default',
  },
  shape: {
    type: String as PropType<Shape>,
    required: false,
    default: 'rectangle',
  },
  size: {
    type: String as PropType<Size>,
    required: false,
    default: 'default',
  },
});

// Computed
const internalHeightComputed = computed(() => {
  if (props.height === 'field') {
    return `${(Sizes as any)[props.height]}rem`;
  } else {
    return `${(Sizes as any)[props.height] * 1.5}rem`;
  }
});

const internalSizeComputed = computed(() => {
  return `${(Sizes as any)[props.size]}rem`;
});
</script>